import React, { useState, useEffect } from 'react';
import './Timer.css';
import formatTime from '../../common/formatTime';
import logComponent from '../../common/logComponent';

export default function Timer({ startTime }) {
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [timeUpdateInterval, setTimeUpdateInterval] = useState(null);

  if (logComponent('Timer')) { console.debug('Timer rendered'); }

  useEffect(() => {
    if (logComponent('Timer')) { console.debug('Timer onMount'); }
    setTimeUpdateInterval(setInterval(updateTime, 500));
    return () => {
      if (timeUpdateInterval) clearInterval(timeUpdateInterval);
    };
  }, [])

  const updateTime = () => {
    if (logComponent('Timer')) { console.debug('Timer updateTime'); }
    setTimeElapsed(Date.now() - startTime);
  }

  return (
    <div className="Timer">
      [<div className="Timer__numbers">{formatTime(timeElapsed)}</div>]
    </div>
  );
}